import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { PdfTicketContext } from './services/pdf-ticket-context.service';

/**
 * Reescreve a base das requests de API quando a página de print roda por origem
 * interna (render do Selenium sem passar pelo Cloudflare): o job envia
 * `?apiBase=...` (ex.: `/api/1.0`, com o nginx da instância fazendo proxy para o
 * Java local) e o `PdfTicketContext` guarda o override ANTES da primeira request.
 *
 * Sem override (fluxo público, dev local), é passthrough — nenhuma heurística de
 * hostname.
 */
@Injectable()
export class ApiBaseInterceptor implements HttpInterceptor {

  constructor(private ticketContext: PdfTicketContext) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const override = this.ticketContext.apiBaseOverride;

    if (override && request.url.startsWith(environment.apiURL)) {
      request = request.clone({
        url: override + request.url.substring(environment.apiURL.length)
      });
    }

    return next.handle(request);
  }
}
